import React from "react";
import PropTypes from "prop-types";

import YMap from "components/YMap";

const YMapAddress = ({
    width,
    height,
    zoom,
    placeMarks = [],
    center,
    onClickMap,
    isSchool,
    logoUrl,
    selectedId,
    isMobile,
    withCluster,
}) => {
    let _center = [56.838071, 60.597407];
    if (!center && placeMarks.length > 0) {
        _center = placeMarks[0].coords;
    }

    return (
        <YMap
            center={_center}
            placeMarks={placeMarks}
            height={height}
            width={width}
            zoom={zoom}
            onClickMap={onClickMap}
            isSchool={isSchool}
            logoUrl={logoUrl}
            selectedId={selectedId}
            isMobile={isMobile}
            withCluster={withCluster}
        />
    );
};

YMapAddress.propTypes = {
    center: PropTypes.arrayOf(PropTypes.string),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    zoom: PropTypes.number,
    onClickMap: PropTypes.func,
    placeMarks: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            coords: PropTypes.arrayOf(PropTypes.string),
            properties: PropTypes.object,
            options: PropTypes.object,
        })
    ),
    isSchool: PropTypes.bool,
    logoUrl: PropTypes.string,
    selectedId: PropTypes.number,
    isMobile: PropTypes.bool,
    withCluster: PropTypes.bool,
};

export default YMapAddress;
